import { Components, Theme } from '@mui/material/styles';

export const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  defaultProps: {
    color: 'default',
  },
  styleOverrides: {
    root: ({ theme }) => {
      return {
        padding: theme.spacing(8),
      };
    },
  },
};
